import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/showToaster';
import { updateSearchSettings } from '../../../lib/graphql/admin/commonSiteAdmin';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: updateSearchSettings,
      variables: {
        id: values?.id,
        minPrice: parseFloat(values?.minPrice),
        maxPrice: parseFloat(values?.maxPrice),
        priceRangeCurrency: values?.priceRangeCurrency
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateSearchSettings?.status === "success") {
    showToaster({ messageId: 'updateSearchSettings', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'searchSettingError', toasterType: 'error' })
  }

}

export default submit;
